//@ts-ignore
export const TAUGA_AI_LOGO_1 = require("./Tauga_Logo.jpg");
export const ROTCHILD_LOGO_1 = require("./Rotchild_Logo.jpg");

